import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "paper-plane",
  "use": "paper-plane-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"paper-plane\"><path d=\"M29 5.63a1.15 1.15 0 000-.19.66.66 0 010-.14c0-.07-.05-.14-.07-.21s0-.06 0-.09a1.3 1.3 0 00-.15-.18l-.08-.09a.78.78 0 00-.2-.11h-.09a1.14 1.14 0 00-.33 0h-.09a1 1 0 00-.24 0l-25 9.74a1 1 0 00-.11 1.81L9 19.6V26a1 1 0 00.62.92.84.84 0 00.38.08 1 1 0 00.71-.29L14 23.39l4.37 3.4A1 1 0 0019 27h.25a1.06 1.06 0 00.67-.57l9-20.51v-.11a.83.83 0 00.08-.18zm-7.43 3.43L9.91 17.82l-4.53-2.45zM11 23.59V21l1.43 1.12zm7.6.83l-7-5.41L25.55 8.57z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/paper-plane.svg
// module id = mYHx
// module chunks = 39 44